module.exports = __webpack_public_path__ + "static/media/02.2ed7a070.png";